import { useTranslation } from "react-i18next";

type PaddockTimeLegendProps = {
  maxOcupacao: number;
  maxDescanso: number;
};

export function PaddockTimeLegend({ maxOcupacao, maxDescanso }: PaddockTimeLegendProps) {
  const { t, i18n } = useTranslation();
  const formatNumber = (num: number) => {
    return new Intl.NumberFormat(i18n.language, { maximumFractionDigits: 2 }).format(num);
  };

  return (
    <section className="capacitybvroute__barnumber--container">
      {maxOcupacao !== 0 && (
        <div>
          <strong className="capacitybvroute__barnumber--title">{t("mapLegend.occupationDays")}</strong>
          <div className="paddocktime__barnumber--bar1" />
          <div className="paddocktime__barnumber--containerlegend">
            <span>0</span>
            <span>{formatNumber(Number(maxOcupacao))}</span>
          </div>
        </div>
      )}
      <br />
      {maxDescanso !== 0 && (
        <div>
          <strong className="capacitybvroute__barnumber--title">{t("mapLegend.restDays")}</strong>
          <div className="paddocktime__barnumber--bar2" />
          <div className="paddocktime__barnumber--containerlegend">
            <span>0</span>
            <span>{formatNumber(Number(maxDescanso))}</span>
          </div>
        </div>
      )}
    </section>
  );
}
